module.exports = "https://web-assets.ifttt.com/packs/media/docs/edit-connection-722f7c6e.png";